import React, { Suspense } from 'react';
import { Outlet, Navigate, useLocation, useNavigate } from 'react-router-dom';
import QueryString from 'query-string';
import { Layout as AntdLayout } from 'antd';
// import IMG_LOGO from '@/images/logo.png';
import { isLogin, setLogin, setToken } from '@/core/authUtil';
import Menu from './Menu';
import Profile from './Profile';

require('./style.less');

const { Header: AntdHeader, Content, Sider } = AntdLayout;

const Logo = () => {
  const navigate = useNavigate();
  return (
    <div className='logo' onClick={() => { navigate('/'); }}>
      {/* <img className='logo-img' alt="logo" src={IMG_LOGO} /> */}
      山海引擎
    </div>
  );
}

const Layout = () => {
  const location = useLocation();
  const login = isLogin();
  const { search } = location;
  const { token } = QueryString.parse(search);
  if (token) {
    console.log('有token', token);
    setLogin();
    setToken(token);
  } else if (!login) {
    return <Navigate to="/login" state={location} />
  }
  return (
    <AntdLayout className="layout">
      <Sider className="left-sider" width={220}>
        <Logo />
        <Menu />
      </Sider>
      <AntdLayout className="right-layout">
        <AntdHeader className="header">
          <Profile />
        </AntdHeader>
        <Suspense fallback={<div>loading...</div>}>
          <Content className="content">
            <Outlet />
          </Content>
        </Suspense>
      </AntdLayout>
    </AntdLayout>
  )
}

export default Layout;